import ReactComponent from '../app/ReactComponent'
import {Link} from 'react-router-dom'
import {Space, Layout, Row, Col, Image, Typography, Spin, Button, Card} from 'antd'
import {
  AP_BOOKING_STATUS_ACTIVE_ID,
  AP_BOOKING_STATUS_ARRIVED_ID, AP_BOOKING_STATUS_ARRIVED_ON_TIME_ID,
  AP_BOOKING_STATUS_RESOLVED_ID
} from '../helpers/misc'
import Query from '../app/Query'
import {mapBookings} from '../services/bookings'
import {PROPERTY_BOOKINGS_STORE_KEY} from '../helpers/properties'
import dayjs from 'dayjs'
import HealthConditionSVG from '../image/dashboard/zdavotni_stav.svg'
import CollectionAppointmentSVG from '../image/dashboard/rezervace_odberu.svg'
import ProfileSVG from '../image/dashboard/muj_profil.svg'
import AmberAccountSVG from '../image/dashboard/amber_konto.svg'
import AvatarManSVG from '../image/dashboard/avatar_muz.svg'
import AvatarWomanSVG from '../image/dashboard/avatar_zena.svg'
import {NavTileItem} from '../components/layout/NavTileItem'
import {ArrowRightOutlined} from '@ant-design/icons'

export class DashboardPage extends ReactComponent {
  state = {
    loading_page: true,
    loading_ongoing_booking: false,
    gender: 1,
    salutation: '',
    constants: {
      AP_BOOKING_STATUS_ARRIVED_ID,
      AP_BOOKING_STATUS_ACTIVE_ID,
      AP_BOOKING_STATUS_RESOLVED_ID
    },
    previous_bookings: [],
    ongoing_booking: null,
    show_survey_registration_btn: false,
    show_additional_information_btn: false,
    show_survey_annual_btn: false,
    show_survey_prvodarce_btn: false,
    show_survey_obnoveni_kvalifikace_btn: false,
    is_mandatory_data_required: false
  }

  async componentDidMount() {

    this.scrollToTop()

    this.pushPageAnalytics('Moje Amber')

    try {

      void this.getOngoingBookings()

      const personal_information = await this.$app.$store('account').getPersonalInfo()

      await this.updateState({
        gender: personal_information.gender,
        salutation: personal_information.salutation,
        is_mandatory_data_required: !personal_information.birthdate,
        loading_page: false
      })

      const {segment_records = []} = await this.$api({
        action: 'carecloud_user_api',
        route: 'segment-records'
      })

      void this.updateState({
        show_survey_registration_btn: await this.$app.$store('account').isAllowedToShowRegistrationSurvey(segment_records),
        show_additional_information_btn: await this.$app.$store('account').isAllowedToShowAdditionalInfoForm(segment_records),
        //show_survey_annual_btn: await this.$app.$store('account').isAllowedToShowAnnualSurvey(segment_records),
        //show_survey_prvodarce_btn: await this.$app.$store('account').isAllowedToShowPrvodarceSurvey(segment_records),
        show_survey_obnoveni_kvalifikace_btn: await this.$app.$store('account').isAllowedToShowObnoveniKvalifikaceSurvey(segment_records)
      })

    } catch (error) {
      this.handleError(error)
    } finally {

    }

  }

  async getOngoingBookings() {

    await this.updateState({
      loading_ongoing_booking: true
    })

    const query = new Query('bookings')

    query.add('sort_field', 'created_at')
    query.add('sort_direction', 'desc')
    query.add('add_booking_items', 'full')
    query.add('booking_statuses', [AP_BOOKING_STATUS_ARRIVED_ID, AP_BOOKING_STATUS_ACTIVE_ID, AP_BOOKING_STATUS_ARRIVED_ON_TIME_ID])

    const {bookings = []} = await this.$api({
      action: 'carecloud_api',
      route: query.route
    })

    await this.updateState({
      previous_bookings: mapBookings(bookings),
      loading_ongoing_booking: false
    })

    await this.checkForOngoingBookings()

    // PREPARE DATA FOR ONGOING BOOKING
    if(this.state.ongoing_booking)
      await this.updateState({
        ongoing_booking: {
          store_name: this.getBookingStoreName(this.state.ongoing_booking.additional_properties),
          date: dayjs(this.state.ongoing_booking.valid_from).format('D.M.YYYY'),
          time: dayjs(this.state.ongoing_booking.valid_from).format('H:mm')
        }
      })
  }

  getBookingStoreName(additional_properties = []) {

    const {property_value: booking_stores = []} = (additional_properties.find(({property_id}) => property_id === PROPERTY_BOOKINGS_STORE_KEY) ?? {})
    const store_property_value = (booking_stores.length ? booking_stores.map(({name}) => name) : [this.$app.$tc('common.unknown', 2)])

    return store_property_value[0].split(', ').slice(1, 2).join(', ')

  }

  async checkForOngoingBookings() {

    const ongoing_statuses = [
      this.state.constants.AP_BOOKING_STATUS_ARRIVED_ID,
      this.state.constants.AP_BOOKING_STATUS_ACTIVE_ID
    ]

    const ongoing_bookings = this.state.previous_bookings.filter(({booking_item_status}) => ongoing_statuses.includes(booking_item_status))

    if(ongoing_bookings.length > 0)
      await this.updateState({ongoing_booking: ongoing_bookings[0]})
  }

  render() {
    return (
      <Spin spinning={this.state.loading_page} size={'large'}>
        <Layout tagName="main"
                className={'dashboard ' + (this.state.gender === 2 ? 'female' : 'male')}>
          <Row align="top" justify="center" gutter={[20, 20]}>
            <Col xs={0} md={24} lg={12} xl={8} className="left-col">
              <Space direction="vertical">

                <Typography.Title level={1} style={{textTransform: 'uppercase'}}>Vítej<br/><span style={{fontWeight: 900}}>{this.state.salutation}</span></Typography.Title>
                <Image preview={false} src={this.state.gender === 2 ? AvatarWomanSVG : AvatarManSVG}/>
                <Typography.Title level={3} className="mt-1">Děkujeme, že pomáháš<br/> zachraňovat lidské životy</Typography.Title>
              </Space>
            </Col>
            <Col xs={24} md={0} className="left-col-mobile">
              <Row justify="center">
                <Col flex="none">
                  <Typography.Title level={1} style={{textTransform: 'uppercase', textAlign: 'left', display: 'inline-block'}}>Vítej<br/><span style={{fontWeight: 700}}>{this.state.salutation}</span></Typography.Title>
                </Col>
                <Col flex="none">
                  <Image preview={false} src={this.state.gender === 2 ? AvatarWomanSVG : AvatarManSVG}/>
                </Col>
                <Col span={24}>
                  <Typography.Title level={5} className="mt-1" style={{fontWeight: 600}}>Děkujeme, že pomáháš<br/> zachraňovat lidské životy</Typography.Title>
                </Col>
              </Row>
            </Col>
            <Col md={24} lg={12} xl={9} xxl={7} className="right-col">

              {this.state.is_mandatory_data_required ?

                <Row>
                  <Col span={24} style={{margin: 0}}>
                    <Card bordered={false} className="mt-1" style={{borderRadius: '1em', margin: '0.5em', boxShadow: 'none'}}>
                      <strong className="ta-left _secondary-text">Doplňte povinné údaje</strong>
                      <p className="ta-left mt-1">Pro rezervaci odběru je nutné mít vyplněné povinné údaje.</p>
                      <Link to={'/profile-update'}>
                        <Button type="primary" className="btn btn-primary">Doplnit údaje</Button>
                      </Link>
                    </Card>
                  </Col>
                </Row>

                :

                <>

                  <Row>

                    {this.state.show_additional_information_btn &&

                      <Col span={24} style={{margin: 0}}>
                        <Card bordered={false} className="mt-1" style={{borderRadius: '1em', margin: '0.5em', boxShadow: 'none'}}>
                          <strong className="ta-left _secondary-text">Chcete zkrátit čas v dárcovském centru?</strong>
                          <p className="ta-left mt-1">Vyplněním doplňujících údajů to zvládnete rychleji. Není to povinné, ale pomůže to.</p>
                          <Link to={'/profile-update-other'}>
                            <Button type="primary" className="btn btn-secondary">Přidat doplňující informace</Button>
                          </Link>
                        </Card>
                      </Col>

                    }

                    {this.state.show_survey_registration_btn &&

                      <Col span={24} style={{margin: 0}}>
                        <Card bordered={false} className="mt-1" style={{borderRadius: '1em', margin: '0.5em', boxShadow: 'none'}}>
                          <strong className="ta-left _secondary-text">Dotazník - Registrace</strong>
                          <p className="ta-left mt-1">Pro urychlení vaší první návštěvy vyplňte tento dotazník maximálně <strong>48 hodin před první schůzkou.</strong></p>
                          <Link to={'/survey'}>
                            <Button type="primary" className="btn btn-secondary">Vyplnit dotazník</Button>
                          </Link>
                        </Card>
                      </Col>

                    }

                    {this.state.show_survey_prvodarce_btn &&

                      <Col span={24} style={{margin: 0}}>
                        <Card bordered={false} className="mt-1" style={{borderRadius: '1em', margin: '0.5em', boxShadow: 'none'}}>
                          <strong className="ta-left _secondary-text">Dotazník - Prvodárce</strong>
                          <p className="ta-left mt-1">Pro urychlení vaší návštěvy vyplňte tento dotazník maximálně <strong>48 hodin před schůzkou.</strong></p>
                          <Link to={'/survey-prvodarce'}>
                            <Button type="primary" className="btn btn-secondary">Vyplnit dotazník</Button>
                          </Link>
                        </Card>
                      </Col>

                    }

                    {this.state.show_survey_annual_btn &&

                      <Col span={24} style={{margin: 0}}>
                        <Card bordered={false} className="mt-1" style={{borderRadius: '1em', margin: '0.5em', boxShadow: 'none'}}>
                          <strong className="ta-left _secondary-text">Dotazník - Roční prohlídka</strong>
                          <p className="ta-left mt-1">Je nutné vyplnit formulář pro Roční prohlídku.</p>
                          <Link to="/survey-annual">
                            <Button type="primary" className="btn btn-secondary">Vyplnit <ArrowRightOutlined style={{marginLeft: '1em'}}/></Button>
                          </Link>
                        </Card>
                      </Col>

                    }

                    {this.state.show_survey_obnoveni_kvalifikace_btn &&

                      <Col span={24} style={{margin: 0}}>
                        <Card bordered={false} className="mt-1" style={{borderRadius: '1em', margin: '0.5em', boxShadow: 'none'}}>
                          <strong className="ta-left _secondary-text">Dotazník - Obnovení kvalifikace</strong>
                          <p className="ta-left mt-1">Pro urychlení vaší návštěvy vyplňte tento dotazník maximálně <strong>48 hodin před schůzkou.</strong></p>
                          <Link to={'/survey-obnoveni-kvalifikace'}>
                            <Button type="primary" className="btn btn-secondary">Vyplnit dotazník</Button>
                          </Link>
                        </Card>
                      </Col>

                    }
                  </Row>

                  <Row justify="center">

                    <Col span={12}>
                      <Spin spinning={this.state.loading_ongoing_booking} size={'large'}>

                        {this.state.ongoing_booking &&
                          <Link to="/reservations" style={{color: 'inherit'}}>
                            <div className="nav-tile-item">
                              <p style={{lineHeight: 1.5}}><strong>{this.state.ongoing_booking.date}</strong><br/>
                                v {this.state.ongoing_booking.time} h<br/>
                                {this.state.ongoing_booking.store_name}</p>

                              <Typography.Title level={4} style={{marginTop: 0}}>Rezervováno</Typography.Title>
                            </div>
                          </Link>
                        }

                        {!this.state.ongoing_booking &&
                          <Link to="/reservation">
                            <NavTileItem icon={CollectionAppointmentSVG} title="Rezervace odběru"/>
                          </Link>
                        }

                      </Spin>
                    </Col>

                    <Col span={12}>
                      <Link to="/health">
                        <NavTileItem icon={HealthConditionSVG} title="Zdravotní stav"/>
                      </Link>
                    </Col>

                    <Col span={12}>
                      <Link to="/profile">
                        <NavTileItem icon={ProfileSVG} title="Můj profil"/>
                      </Link>
                    </Col>

                    <Col span={12}>
                      <Link to="/rewards">
                        <NavTileItem icon={AmberAccountSVG} title="Amber Klub"/>
                      </Link>
                    </Col>

                    <Col span={24} className="advertising">
                      <Space style={{margin: '0.5em', maxWidth: 339}} size={[0, 0]}>
                        <a href="https://www.amberplasma.com/" target="_blank" rel="noreferrer">
                          <Image className="" preview={false} src={require('../image/dashboard/prived_kamarada.png')}/>
                        </a>
                      </Space>
                    </Col>

                  </Row>

                </>

              }

            </Col>
          </Row>
        </Layout>
      </Spin>
    )
  }
}